import { defineComponent as w, useSlots as i, createElementBlock as a, openBlock as r, createCommentVNode as f, createElementVNode as s, unref as l, normalizeClass as n, renderSlot as o } from "vue";
const p = {
  class: "stash-card tw-relative tw-inline-block tw-rounded tw-border tw-bg-white tw-shadow-md",
  "data-test": "stash-card"
}, h = /* @__PURE__ */ w({
  __name: "Card",
  props: {
    detachActions: { type: Boolean, default: !1 }
  },
  setup(d) {
    const c = d, t = i();
    return (e, u) => (r(), a("article", p, [
      l(t)["top-left"] || l(t)["top-right"] ? (r(), a("div", {
        key: 0,
        "data-test": "card-actions",
        class: n([{ "tw-absolute tw-top-0 tw-w-full": c.detachActions }, "tw-flex tw-flex-wrap tw-items-start tw-justify-between tw-p-6"])
      }, [
        s("div", null, [
          o(e.$slots, "top-left")
        ]),
        s("div", null, [
          o(e.$slots, "top-right")
        ])
      ], 2)) : f("", !0),
      s("div", {
        class: n({ "tw-mb-6 tw-flex tw-h-full tw-flex-col tw-gap-y-6": l(t).default })
      }, [
        o(e.$slots, "default")
      ], 2)
    ]));
  }
});
export {
  h as default
};
//# sourceMappingURL=Card.js.map
